<template>
  <v-text-field
    v-model="foo"
    type="number"
    :outlined="outlined"
    :filled="filled"
    :label="label"
    append-icon="mdi-plus"
    @click:append="increment"
    prepend-inner-icon="mdi-minus"
    @click:prepend-inner="decrement"
    hide-details
    dense
    class="centered-input inputPrice"
    style="width: 110px; text-align: center"
  ></v-text-field>
</template>

<script>
export default {
  props: {
    value: Number,
    label: String,
    filled: Boolean,
    outlined: Boolean,
    changed: Function,
    min: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      foo: this.value,
    };
  },
  methods: {
    increment() {
      this.foo = parseInt(this.foo, 10) + 1;
    },
    decrement() {
      this.foo = Math.max(parseInt(this.foo, 10) - 1, this.min);
    },
  },
  watch: {
    foo(val) {
      this.$emit("input", parseInt(this.foo));
    },
    value(val) {
      this.foo = parseInt(val);
    },
  },
};
</script>

<style>
.centered-input input {
  text-align: center;
}

.inputPrice input[type="number"] {
  -moz-appearance: textfield;
}
.inputPrice input::-webkit-outer-spin-button,
.inputPrice input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>


